import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=3af2a8c7&scoped=true&"
import script from "./branches.vue?vue&type=script&lang=js&"
export * from "./branches.vue?vue&type=script&lang=js&"
import style0 from "./branches.vue?vue&type=style&index=0&id=3af2a8c7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2a8c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af2a8c7')) {
      api.createRecord('3af2a8c7', component.options)
    } else {
      api.reload('3af2a8c7', component.options)
    }
    module.hot.accept("./branches.vue?vue&type=template&id=3af2a8c7&scoped=true&", function () {
      api.rerender('3af2a8c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/branches/branches.vue"
export default component.exports